// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"280":"166b460e","565":"166b460e"}[chunkId] + ".chunk.css";
};